import { useEffect, useRef, useState } from 'react'

import { PSApplication } from '../components/app/PSApplication'
import { User } from '../models/User'

export const usePSUser = () => {
    // todo this method needs to go away
    return PSApplication.me()
}

export const usePSOwner = () => {
    const user = PSApplication.me()
    const [employer, setEmployer] = useState<User>()

    useEffect(() => {
        if (!['admin', 'employee'].includes(user?.role ?? '') || !user?.employer?.id) {
            // No employer, your the boss or single man show
            setEmployer(user)
        }
        else {
            setEmployer(user.employer)
        }
    }, [user])

    return employer
}

export const useInterval = (callback: Function, delay: number) => {
    const savedCallback = useRef<Function>()
    useEffect(() => {
        savedCallback.current = callback
    }, [callback])

    useEffect(() => {
        let id: NodeJS.Timeout
        const tick = async () => {
            try {
                if (!savedCallback.current) {
                    return
                }

                await savedCallback.current()
                id = setTimeout(tick, delay)
            }
            catch (e) {
                console.error(e)
            }
        }
        tick()

        return () => id && clearTimeout(id)
    }, [delay])
}
